import { Result, Err, IConversation, ConversationRequests, IUser } from '@/classes'

export const requestCreateAPI = async (
  targetId: string,
  type: typeof ConversationRequests[number],
  options?: {
    message?: string
		isRewarded?: boolean
  }
) => {
	const response: Result<{
		conversation: IConversation | null
		requests: number
	}> = await fetchAPI('request/create', { targetId, type, options }, { method: 'POST' })

	return response
}